import { ApolloClient, createHttpLink, InMemoryCache } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { accessTokenStorage } from './auth';

// import fragmentTypes from '../fragmentTypes';

// const fragmentMatcher = new IntrospectionFragmentMatcher({
//   introspectionQueryResultData: fragmentTypes
// });

const httpLink = createHttpLink({
  credentials: 'same-origin',
  uri: process.env.REACT_APP_GRAPHQL_API_URL
});

const authLink = setContext(async (_, { headers }) => {
  const token = accessTokenStorage.get();

  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : ''
    }
  };
});

// Cache configuration to prevent excessive refetching
const cache = new InMemoryCache({
  typePolicies: {
    Query: {
      fields: {
        // Cache rooms for 5 minutes to prevent excessive refetching
        getPaginatedRooms: {
          merge(existing = [], incoming) {
            return [...incoming];
          }
        },
        getPaginatedRoomsByType: {
          merge(existing = [], incoming) {
            return [...incoming];
          }
        },
        // Cache room messages and merge properly
        getRoom: {
          merge(existing, incoming) {
            return incoming;
          }
        }
      }
    },
    Room: {
      keyFields: ['id'],
      fields: {
        messages: {
          merge(existing = [], incoming) {
            // Simple merge - just return incoming messages
            return incoming;
          }
        }
      }
    },
    User: {
      keyFields: ['id']
    },
    Message: {
      keyFields: ['id']
    }
  }
});

export const apolloClient = new ApolloClient({
  cache,
  link: authLink.concat(httpLink),
  // Reduce network-only fetches to prevent loops
  defaultOptions: {
    watchQuery: {
      fetchPolicy: 'cache-and-network',
      errorPolicy: 'ignore'
    },
    query: {
      fetchPolicy: 'cache-first',
      errorPolicy: 'all'
    }
  }
});
